const FormField = {
  REST_TIME: 'rest',
  REST_TIME_DISPLAY_UNIT: 'restTimeDisplayUnit',
};

export default FormField;
